import { render, staticRenderFns } from "./AftLoading.vue?vue&type=template&id=67644802&scoped=true"
import script from "./AftLoading.vue?vue&type=script&lang=js"
export * from "./AftLoading.vue?vue&type=script&lang=js"
import style0 from "./AftLoading.vue?vue&type=style&index=0&id=67644802&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67644802",
  null
  
)

export default component.exports